import { getAutocomplete } from "../services/Autocomplete";
import { getRequestCountry } from "../services/RequestCountry";
import { getSearch } from "../services/Search";
import { getCheckout } from "../services/Checkout";
import { getBooking } from "../services/Booking";
import { getLogin } from "../services/Login";
import { getSession } from "../services/Session";
//import { getLogout } from "../services/Logout";

//import moment from 'moment';
import "moment/locale/es";
import "moment-timezone";

export const getRestore = () => {
  return {
    type: "RESTORE",
  };
};

export const addAction = (
  itemsCart,
  totalPrice,
  idPrice,
  pricesItem,
  segmentState
) => {
  return {
    type: "SELECT_TRAIN",
    itemsCart: itemsCart,
    totalPrice: totalPrice,
    pricesItem: pricesItem,
    segmentState: segmentState,
    idPrice: idPrice,
  };
};

export const getRequestCountryAction = async (tokenClient) => {
  const response = await getRequestCountry(tokenClient);

  let destinos = [];
  // if (response !== false) {
  //     if (response.data.data.length > 0) {
  //         response.data.data.map(elemnt => {
  //             let category = elemnt.category;
  //             elemnt.data.map(value => {
  //                 destinos.push({ category: category, label: value.label + ' - ' + value.code + ' - ' + value.type });

  //             })

  //         })
  //     }
  // }

  return {
    type: "GET_REQUESTCOUNTRY",
    payload: response.data,
  };
};

export const getAutocompleteAction = async (query, apiUrl) => {
  const response = await getAutocomplete(query, apiUrl);

  let destinos = [];
  if (response !== false) {
    if (response.data.length > 0 && query !== "") {
      response.data.map((elemnt) => {
        let category = elemnt.type === "city" ? "Ciudad" : "Estación";
        destinos.push({
          category: category,
          label:
            elemnt.label +
            ", " +
            elemnt.country.label +
            " | " +
            elemnt.code +
            " | " +
            elemnt.type,
        });
      });
    }
  }

  return {
    type: "GET_AUTOCOMPLETE",
    payload: destinos,
  };
};

export const preloadAction = async (preload) => {
  return {
    type: "UPDATE_PRELOAD",
    payload: preload,
  };
};

export const getSearchAction = async (
  origin,
  destination,
  departure,
  time,
  ages,
  tramos,
  tokenClient,
  apiToken,
  directOnly
) => {
  //se elimina datos de timer
  localStorage.removeItem("seconds");
  localStorage.removeItem("minutes");
  localStorage.removeItem("expired");

  sessionStorage.setItem("preloadResult", true);

  let agesRequest = [];
  let legsRequest = [];
  let agesVal = [];
  let searchType = "point_to_point";

  ages.map((value) => {
    agesRequest.push({ age: value });
    agesVal.push({ ageInput: value });
  });

  let departureTime = "";

  origin.map((value, i) => {
    let typeCodeOrigin = value.split("__");
    let typeCodeDestination = destination[i].split("__");
    departureTime =
      departure[i] + "T" + time[i].slice(0, 2) + ":" + time[i].slice(2);
    legsRequest.push({
      origin: {
        type: typeCodeOrigin[0],
        code: typeCodeOrigin[1].split("-").join("#"),
      },
      destination: {
        type: typeCodeDestination[0],
        code: typeCodeDestination[1].split("-").join("#"),
      },
      departure: departureTime,
      directOnly: false,
    });
  });

  const valueRequest = {
    tramos: tramos,
    edades: agesVal,
    tokenClient: tokenClient,
    //   "departureInput":departureInput
  };

  const request = {
    travelers: agesRequest,
    business: { token: apiToken },
    legs: legsRequest,
  };

  const response = await getSearch(request, tokenClient, searchType);

  sessionStorage.removeItem("preloadResult");

  return {
    type: "GET_SEARCH",
    payload: response.data,
    dataRequest: valueRequest,
    directOnly: directOnly,
  };
};

// start getSearchPassesAction //
export const getSearchPassesAction = async (
  origin,
  departure,
  time,
  ages,
  tramos,
  tokenClient,
  apiToken,
  searchSelection
) => {
  //se elimina datos de timer
  localStorage.removeItem("seconds");
  localStorage.removeItem("minutes");
  localStorage.removeItem("expired");

  sessionStorage.setItem("preloadResult", true);

  let agesRequest = [];
  let legsRequest = [];
  let agesVal = [];
  let place = [];
  let departureTime = { validityStartDate: departure[0] };
  let searchType = "passes";
  let firstKeyProducts = [];

  ages.map((value) => {
    agesRequest.push({ age: value });
    agesVal.push({ ageInput: value });
  });

  const valueRequest = {
    tramos: tramos,
    edades: agesVal,
    tokenClient: tokenClient,
    searchSelection: searchSelection,
    firstKeyProducts: firstKeyProducts,
  };

  const request = {
    place: { code: origin },
    business: { token: apiToken },
    travelers: agesRequest,
    validityStartDate: departure[0],
  };

  const response = await getSearch(request, tokenClient, searchType);
  sessionStorage.removeItem("preloadResult");

  response.data.products.map((value) => {
    firstKeyProducts.push(value.durations[0].key);
  });

  return {
    type: "GET_SEARCH_PASSES",
    payload: response.data,
    dataRequest: valueRequest,
  };
};
// end getSearchPassesAction //

export const getCheckoutAction = async (
  extraInfo,
  itemCart,
  tokenClient,
  apiToken,
  x_correlation_id
) => {
  let items = [];
  let request = null;

  if (Array.isArray(itemCart)) {
    // If Tickets/PointToPoint
    itemCart.map((value) => {
      items.push({ location: value.trainId.location });
    });
    request = {
      x_correlation_id: x_correlation_id,
      items: items,
    };
  } else {
    // If Passes/Offer
    items.push({ location: itemCart });
    request = {
      x_correlation_id: x_correlation_id,
      items: items,
      info: extraInfo,
    };
  }

  const response = await getCheckout(request, tokenClient, apiToken);

  return {
    type: "GET_CHECKOUT",
    payload: response.data,
  };
};

export const getBookingAction = async (request, tokenClient, apiToken) => {
  const response = await getBooking(request, tokenClient, apiToken);

  return {
    type: "GET_BOOKING",
    payload: response.data,
  };
};

export const saveRequestAction = (request) => {
  return {
    type: "SAVE_REQUEST",
    payload: request,
  };
};

const session = async (eraId, tokenClient, response) => {
  //Descomentar para llamar a la api
  const testSession = await getSession(eraId, tokenClient);

  //const testSession = {"timeToExpire":28,"logged":'true'}
  sessionStorage.setItem(
    "isUserLogged",
    testSession ? testSession.data.logged : false
  );
  sessionStorage.setItem(
    "firstName",
    testSession ? testSession.data.firstName : ""
  );
  sessionStorage.setItem(
    "userName",
    testSession ? testSession.data.userName : ""
  );
  sessionStorage.setItem("eraId", testSession ? testSession.data.eraId : "");
  sessionStorage.setItem("tokenClient", tokenClient);
};

export const loginRequest = async (nameUser, password, tokenClient) => {
  const request = {
    username: nameUser,
    password: password,
    logSession: "true",
  };

  const response = await getLogin(request, tokenClient);

  const responseTextError =
    (response.data && response.data.message) || response.statusText;

  if (responseTextError === "") {
    await session(response.data.eraId, tokenClient);
  }

  return {
    type: "LOGIN_REQUEST",
    payload: response,
    error: responseTextError,
  };
};

export const logoutAction = (/* hash,tokenClient */) => {
  /*   const request = {
          "hash": hash,
      } */
  /*   const response = await getLogout(request,tokenClient); */

  sessionStorage.removeItem("isUserLogged");
  sessionStorage.removeItem("dataUser");
  /*
       return {
           type: 'LOGIN_REQUEST',
       }  */
};

export const saveFirstSearchData = (origin,
  destination,
  departure,
  time,
  ages,
  tramos,
  tokenClient,
  apiToken,
  directOnly) => {
  const firstSearchData = {
    origin,
    destination,
    departure,
    time,
    ages,
    tramos,
    tokenClient,
    apiToken,
    directOnly
  };
  return {
    type: "SAVE_FIRST_SEARCH_DATA",
    payload: firstSearchData,
  };
};